export default {
    intro: `仔细阅读文章，来解答答题喵的题目吧。<br/>
            全部答完后，美味的小零食在等你哦！`,
    next: '下一步',
};
